
import React from 'react';
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import { Grid } from '@mui/material';
import Typography from '@material-ui/core/Typography'
import HelpIcon from "@mui/icons-material/Help";
import ReactTooltip from "react-tooltip";

const classes = {
    lblGraph: {
        backgroundColor: '#F5F5F5',
        color: '#155BCB',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: 3,
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        padding: 10
    },

    gridLabel: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        gap: 5
    },

    graph: {
        border: "1px solid #D1CCCC",
        boxShadow: "0px 3px 3px 0px rgba(0, 0, 0, 0.25)",
        height: "403px",
    },


}

export default function Treemapchart({ occurrences }) {
    const dataMap = {};
    let legends = []

    for (let i = 0, n = occurrences.length; i < n; i++) {
        const occurrence = occurrences[i];
        const complaintTarget = occurrence.complaintTarget;

        if (complaintTarget === undefined) {
            continue
        }

        if (!dataMap[complaintTarget]) {
            dataMap[complaintTarget] = { name: complaintTarget, value: 0 };
            legends.push(complaintTarget)
        }

        dataMap[complaintTarget].value += 1;
    }
    const data = Object.keys(dataMap).map(key => ({
        name: dataMap[key].name,
        value: dataMap[key].value
    }));

    const COLORS = ['#0088FE', '#00C49F'];
    console.log(data)

    return (



        <div id="total-ocurrencies-dashboard" style={{ width: "100%" }}>

            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
                <div style={classes.gridLabel}>
                    <div>Ocorrências por Serviço de Destino:</div>

                    <div style={classes.helpText}>
                        <ReactTooltip id="proportion-info" className="popup" />
                        <HelpIcon
                            style={{ color: "#a1a5ab" }}
                            fontSize="small"
                            data-for="proportion-info"
                            data-place="bottom"
                            data-tip="Um gráfico que mostra as ocorrências por serviço de destino."
                        />
                    </div>
                </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>

                {data.length === 0 ? (
                    <span
                        style={{
                            fontSize: "16px",
                            margin: "30px",
                            textAlign: "center",
                            display: "block",
                        }}
                    >
                        Não há ocorrências
                    </span>

                ) : (

                    <div style={{ display: 'flex' }}>
                        <ResponsiveContainer width="75%" height={400}>
                            <PieChart>
                                <Pie
                                    data={data}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={150}
                                    fill="#8884d8"
                                    label
                                >
                                    {data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>

                                <Tooltip />

                            </PieChart>

                        </ResponsiveContainer>

                        <div style={{ marginTop: 120 }}>

                            {legends.map((legend, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
                                    <div style={{ width: 20, height: 20, backgroundColor: COLORS[index], marginRight: 10 }}></div>
                                    <Typography>{legend}</Typography>
                                </div>
                            ))}
                        </div>
                    </div>


                )
                }

            </Grid>



        </div>

    );
}